/**
 * Only one thumb active at a time
 */
const thumbSelector = '[data-thumb]';

$(document).on('click', thumbSelector, function () {
  const $this = $(this);
  $this.siblings(thumbSelector).removeClass('active');
  $this.addClass('active');
});

$(document).on('click', '[data-itemlist-catalog-toggle]', function() {
  $(this).parent().parent().find('[data-itemlist-catalog-toggle], ul')
    .toggleClass('hide');
});

$(document).on('mouseover', '[data-catalog-navigation]', function() {
  const target = $(`#${$(this).attr('data-toggle')}`);
  target.css('visibility', 'hidden');
  $.ajax({ url: $(this).attr('data-catalog-navigation') }).then((response) => {
    target.html(response).css('visibility', 'visible');
  });
  $(this).removeAttr('data-catalog-navigation');
});
